export const REVIEW_STATUS = {
  pending_assignment: ["badge-neutral", "Pending Assignment"],
  pending_review: ["badge-warning", "Pending Review"],
  in_review: ["badge-info", "In Review"],
  approved: ["badge-success", "Approved"],
  declined: ["badge-danger", "Declined"],
};

export function ReviewStatusBadge({ status, testid }) {
  const [cls, label] = REVIEW_STATUS[status] || ["badge-neutral", status || "—"];
  return <span className={`badge ${cls}`} data-testid={testid}>{label}</span>;
}

export function EscalatedBadge({ testid }) {
  return <span className="badge badge-danger" data-testid={testid}>Escalated</span>;
}

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString("en-NG", { dateStyle: "medium", timeStyle: "short" }) : "—");
